import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

export function Skeleton({
  width,
  height,
  radius,
  className,
}: {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  className?: string;
}) {
  const style: CSSProperties = {
    width,
    height,
    ...(radius !== undefined ? { borderRadius: radius } : {}),
  };
  return <span className={[styles.skeleton, className].filter(Boolean).join(' ')} style={style} />;
}

/** Placeholder card matching the ProductCard footprint. */
export function ProductCardSkeleton() {
  return (
    <div className={styles.card}>
      <Skeleton className={styles.thumb} radius={0} />
      <div className={styles.lines}>
        <Skeleton width="40%" height={12} />
        <Skeleton width="85%" height={18} />
        <Skeleton width="55%" height={22} />
        <Skeleton width="100%" height={40} radius={10} />
      </div>
    </div>
  );
}
